import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge, usePoll, fmtUSDT, fmtINR } from "@/components/common";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("");
  const load = () => api.get(`/admin/orders${filter ? `?status=${encodeURIComponent(filter)}` : ""}`).then((r) => setOrders(r.data)).catch(() => {});
  usePoll(load, 6000, [filter]);

  const filters = ["", "Pending", "Under Review", "Partially Paid", "Payment Sent", "Payment Dispute / Needs Review", "Confirmation Expired", "Completed"];

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Sell Orders</h1>
      <div className="flex gap-2 flex-wrap">
        {filters.map((f) => (
          <button key={f} onClick={() => setFilter(f)} className={`px-3 py-1.5 rounded-full text-xs font-medium ${filter === f ? "bg-blue-600 text-white" : "bg-white border border-slate-200 text-slate-600"}`}>
            {f || "All"}
          </button>
        ))}
      </div>
      {orders.length === 0 ? <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-400">No orders.</div> : (
        <div className="space-y-3" data-testid="admin-orders-list">
          {orders.map((o) => (
            <Link to={`/admin/orders/${o.order_id}`} key={o.order_id} data-testid={`admin-order-row-${o.order_id}`}
              className="bg-white border border-slate-200 rounded-2xl p-5 flex flex-col sm:flex-row sm:items-center gap-3 justify-between hover:shadow-md transition">
              <div>
                <div className="font-mono text-sm text-slate-900">{o.order_id}</div>
                <div className="text-sm text-slate-600 mt-0.5">{o.customer_name} · {fmtUSDT(o.amount)} USDT @ {fmtINR(o.rate)}</div>
                <div className="text-xs text-slate-400 mt-0.5">{new Date(o.created_at).toLocaleString()}</div>
              </div>
              <div className="flex items-center gap-6">
                <div className="text-right text-sm">
                  <div className="text-slate-500">Exp <span className="font-mono text-slate-900">{fmtINR(o.expected_inr)}</span></div>
                  <div className="text-slate-500">Paid <span className="font-mono text-emerald-700">{fmtINR(o.paid_inr)}</span> · Rem <span className="font-mono">{fmtINR(o.remaining_inr)}</span></div>
                </div>
                <StatusBadge status={o.status} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
